import { Component, OnInit } from '@angular/core'
import { ActivatedRoute, Params } from '@angular/router'
import { Router } from '@angular/router'
import { EnrollmentGateway } from '../../gateways/enrollment-gateway'
import { EnrollmentViewModel } from '../../models/enrollment-view-model'
import { EappUpdateStatus } from '../../models/eapp-status-model'
import { PortalGlobals } from '../../../portalglobals'

@Component({
    selector: 'EAppEnrollmentButton',
    templateUrl: 'e-app-enrollmentbutton.component.html'
})
export class EAppEnrollmentButtonComponent implements OnInit {
    id: string
    correction: boolean = false
    hasError: boolean
    ErrorMessages: any[]
    txtCorrection: string
    enrollmentViewModel: EnrollmentViewModel = new EnrollmentViewModel()
    eappUpdateStatusModel: EappUpdateStatus = {} as EappUpdateStatus
    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private _enrollmentGateway: EnrollmentGateway,
        public _global: PortalGlobals
    ) {}
    ngOnInit() {
        var User = localStorage.getItem('UserSessionContext')
        this._global.currentUser = JSON.parse(User!)

        this.getParams()
        if (this.id === '1') {
            this.correction = true
        } else {
            this.correction = false
        }
        this.enrollmentViewModel = this._enrollmentGateway.getEnrollmentViewModel()
    }
    getParams() {
        this.route.params.forEach((params: Params) => {
            this.id = this.route.snapshot.params['id']
        })
    }

    continueClick() {
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
        if (!this.correction) {
            this.eappUpdateStatusModel.ApplicationStatus = 'Rejected'
            this.eappUpdateStatusModel.UniqueLink = this.enrollmentViewModel.UNIQUELINK
            this.eappUpdateStatusModel.LinkExpired = true
            this.eappUpdateStatusModel.LinkViewed = true
            this.eappUpdateStatusModel.Reason = ''
            this._enrollmentGateway.updateEAppStatus(this.eappUpdateStatusModel).subscribe((model: any) => {
                let response = model
                if (response === undefined) {
                    if (response.Errors !== undefined && response.Errors.length > 0) {
                        this.hasError = false

                        for (let i = 0; i < response.Errors.length; i++) {
                            this.ErrorMessages.push(response.Errors[i].ErrorMessage)
                        }
                        this.hasError = true
                        window.scrollTo(0, 0)
                    } else {
                        this.ErrorMessages.push('Error while submitting data, please try again.')
                        this.hasError = true
                        window.scrollTo(0, 0)
                    }
                } else {
                    this.router.navigate(['/' + insCo + '/enrollment/e-application/messages/' + '2'])
                }
            })
        } else {
            this.eappUpdateStatusModel.ApplicationStatus = 'Correction'
            this.eappUpdateStatusModel.UniqueLink = this.enrollmentViewModel.UNIQUELINK
            this.eappUpdateStatusModel.LinkExpired = true
            this.eappUpdateStatusModel.LinkViewed = true
            this._enrollmentGateway.updateEAppStatus(this.eappUpdateStatusModel).subscribe((model: any) => {
                let response = model
                if (response === undefined) {
                    if (response.Errors !== undefined && response.Errors.length > 0) {
                        this.hasError = false

                        for (let i = 0; i < response.Errors.length; i++) {
                            this.ErrorMessages.push(response.Errors[i].ErrorMessage)
                        }
                        this.hasError = true
                        window.scrollTo(0, 0)
                    } else {
                        this.ErrorMessages.push('Error while submitting data, please try again.')
                        this.hasError = true
                        window.scrollTo(0, 0)
                    }
                } else {
                    this.router.navigate(['/' + insCo + '/enrollment/e-application/messages/' + '4'])
                }
            })
        }
    }

    btnBack() {
        this.enrollmentViewModel = this._enrollmentGateway.getEnrollmentViewModel()
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
        this.router.navigate(['/' + insCo + '/enrollment/e-app/' + this.enrollmentViewModel.UNIQUELINK + '/' + 'verify'])
    }
}
